/**
 * Split locale into 2 parts, language code and country code. E.g. from 'en-US' to ['en', 'US']
 * This function will work with both - and _ separator. Also, if locale does not contain country
 * code, this function will return the defaultCountryCode or an empty string if defaultCountryCode is
 * not provided. Country code will never be null or undefined.
 */
export const splitLocale = (locale, defaultCountryCode) => {
    const localeSeparator = locale.indexOf('-') >= 0 ? '-' : '_';
    const parts = locale.split(localeSeparator);
    return [parts[0], parts[1] ? parts[1] : defaultCountryCode || ''];
};
/**
 * Given a language code, find the Language from the list of supported languages that matches the given language code.
 */
export const getLanguageByCode = (supportedLanguages, locale) => {
    if (locale) {
        // NOTE - some locale use - and some use _ to separate language code and country code
        const languageCode = splitLocale(locale)[0].toLowerCase();
        return supportedLanguages.find((language) => {
            return language.code === languageCode;
        });
    }
    return undefined;
};
